import React from 'react'
import { ProgressBar } from 'react-bootstrap'

export default function CustomProgressBar() {
    return (
        <ProgressBar animated now={100} variant="success" className="m-4" label="Loading" />
    )
}
